<template>
    <div class="container" v-show="isShow">
        <a class="popup-close-button" @click="showPage">x</a>
        <div class="content">
            <div class="echartHead">
                <div class="headItem">
                    <span >主机编号</span>
                    <el-select class="headSelect" v-model="gprsAddr" clearable>
                        <el-option
                            v-for="item in ledHostDatas"
                            :key="item.gprsAddr"
                            :label="item.gprsAddr"
                            :value="item.gprsAddr">
                        </el-option>
                    </el-select>  
                </div>
                <div class="headItem">
                    <span >曲线类型</span>
                    <el-select class="headSelect" v-model="hostType" clearable placeholder="请选择">
                        <el-option
                            v-for="item in hostTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>  
                </div>  
            </div>
            <div class="echartHead">
                <div class="headItem dateDiv">
                    <el-date-picker 
                        v-model="currentDate"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </div>
                <div class="headItem">
                    <span>从机编号</span>
                    <el-select class="headSelect" v-model="slaveType" clearable placeholder="请选择">
                        <el-option
                            v-for="item in slaveTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>   
            </div>
            <div>
                <el-button class="btn" type="success" @click="selectDatas"><span class="queryText">查      询</span> </el-button>
            </div>
            <div class="echartBody" ref="echartRef"></div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios';
export default {
    name:'EchartsAbout',
    data(){
        this.theCharts =null
        return {
            isShow:false ,
            main:'',
            ledHostDatas:[],
            gprsAddr:'',
            hostType:'',
            hostTypes:[
                {value:"type001",label:"主机温度曲线"},
                {value:"type002",label:"主机湿度曲线"},
                {value:"type003",label:"主机照度曲线"},
                {value:"type004",label:"主机电压曲线"},
                {value:"type005",label:"从机电压曲线"},
                {value:"type006",label:"从机电流曲线"},
                {value:"type007",label:"能见度曲线"}
            ],
            slaveType:'',
            slaveTypes:[],
            currentDate: dayjs(new Date()).format("YYYY-MM-DD"),
            dataX:[],
            dataY:[],
        }
    },
    watch:{
        hostType:{
            handler(newVal){
                if(newVal == 'type005' || newVal == 'type006'){
                    this.getHostInfo();
                }else{
                    this.slaveType = '';
                    return ;
                }
                // console.log('hostType = ',newVal);
            }
        },
        gprsAddr:{
            handler(newVal){
                if(this.hostType == 'type005' || this.hostType == 'type006'){
                    this.getHostInfo();
                }else{
                    this.slaveType = '';
                    return ;
                }
            }
        }
    },
    methods: {
        showLEDEcharts(){
            this.isShow = !this.isShow ;
        },
        initEcharts(){
            this.main = this.$refs.echartRef ;
            this.theCharts = echarts.init(this.main,'dark');
            this.hostType = this.hostTypes[0].value;
        },
        setChartsOption(){
            let options={
                tooltip:{
                    trigger:'axis',
                    transitionDuration: 0  // 让toolltip紧跟鼠标
                },
                xAxis: {
                    type: 'category',
                    data: this.dataX
                },
                yAxis: {
                    type: 'value'
                },
                grid:{
                    left: '10%' ,
                    top: 60 ,
                    right: '10%' ,
                    bottom: 60 ,
                },
                dataZoom:[
                    {
                        type:'slider',
                        xAxisIndex:0,
                        fliterMode:'none'
                    },
                    {
                        type:'slider',
                        yAxisIndex:0,
                        fliterMode:'none'
                    },
                ],
                series: [
                    {
                    data: this.dataY,
                    type: 'line'
                    }
                ]
            }
            this.theCharts.setOption(options);
            
            window.addEventListener("resize",()=>{
                this.theCharts.resize();
        })
        },
        LEDHostListDatas(ledDatas){
            this.ledHostDatas = ledDatas;
            this.gprsAddr = ledDatas[0].gprsAddr ;
            // console.log('EchartsAbout组件 接收到LEDHostList数据:',ledDatas);
        },
        getHostInfo(){
            axios.get('http://47.111.99.118:8089/system/GETHOSTINFO?GETHOSTINFO').then(
                response=>{
                    // console.log('GETHOSTINFO=',response.data.data);
                    this.slaveTypes = [];
                    let hostArr = response.data.data;
                    hostArr.forEach(el=>{
                        if(el.gprsAddr == this.gprsAddr){
                            this.slaveType = 1;
                            for(let i=0 ; i<el.clientNum ; i++){
                                let slave = {value:'slave'+i,label:i+1};
                                this.slaveTypes.push(slave);
                            }
                        }
                    })
                },
                error=>{
                    console.log('error GETHOSTINFO=',error.message);
                }
            )
        },
        selectDatas(){
            console.log("EchartsAbout 组件 selectDatas")
            let gA = this.gprsAddr;
            let hT = this.hostType;
            let sT = this.slaveType;
            let cDate = this.currentDate ;
            if(hT == "type001"){
                hT = "temp";
            }else if(hT == "type002"){
                hT = "dampness";
            }else if(hT == "type003"){
                hT = "lux";
            }else if(hT == "type004"){
                hT = "voltage";
            }else if(hT == "type005"){
                hT = "volSlave";
            }else if(hT == "type006"){
                hT = "aSlave";
            }else if(hT == "type007"){
                hT = "VD";
            }
            let url = '';
            if(sT == "")
                url = "http://47.111.99.118:8089/system/getChartData?chartType=" + hT + "&startTime=" + cDate + "&hostID=" + gA ;
            else
                url = "http://47.111.99.118:8089/system/getChartData?chartType=" + hT + "&startTime=" + cDate + "&hostID=" + gA + "&slaveID=" + sT;

            axios.get(url).then(
                response=>{
                    if(response.data.msg == "未查询到符合条件的记录"){
                        alert("未查询到符合条件的记录");
                        return ;
                    }
                    console.log("getChartData?chartType=",response.data);
                    this.dataX = response.data.dataX;
                    this.dataY = response.data.dataY;
                    this.setChartsOption();
                },
                error=>{
                    console.log("error getChartData?chartType=",error.message);
                }
            )
        },
        showPage(){
            this.isShow = !this.isShow ;
        }
    },
    mounted() {
        this.$bus.on('showLEDEcharts',this.showLEDEcharts);
        this.$bus.on('LEDHostListDatas',this.LEDHostListDatas);   
        this.initEcharts();
        console.log("EchartsAbout 组件 mounted")
        window.addEventListener('resize',()=>{
            this.theCharts.resize();
        })
    },
    unmounted(){
        this.$bus.off('LEDHostListDatas');   
        this.$bus.off('showLEDEcharts');   
    }
}
</script>

<style scoped>
@import url("//unpkg.com/element-ui@2.15.14/lib/theme-chalk/index.css");
.container{
    position: absolute;
    top: 5%;
    left: 25%;
    right: 25%;
    bottom: 18%;
    background-color: rgba(1, 6, 35, 0.9);
    color: white;
    border: 1px solid wheat;
    border-radius: 20px;
    overflow: hidden;
}
.echartHead{
    width: 100%;
    display: flex;
    justify-content: space-around;
}
.headItem{
    width: 60%;
    margin-right: 0;
    margin-top: 1%;
}
.dateDiv{
    width: 60%;
}

.headSelect{
    width:60%;
    margin-left: 2%;
}
.btn{
    margin-left: 67%;
    margin-top: 1%;
}
.queryText{
    margin:20px;


}

.echartBody{
    /* position: absolute; */
    margin-top: 5px;
    width: 920PX;

    height:555px;
    /* overflow: hidden; */
}




.content{
    margin-top: 3%;
    width: 100%;
    height: 97%;
    border-radius: 5px;
    overflow: hidden;
    /* border: 1px solid wheat; */
}
.popup-close-button {
    position: absolute;
    top: 0;
    right: 14px;
    padding: 5px 10px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 20px/16px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 9999;
    color: aliceblue;
  }

  .popup-close-button:hover {
    cursor: pointer;
    color: red;
  }
</style>